import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-compiled-file-icon',
  templateUrl: './files-compiled-file.component.html'
})
export class FilesCompiledFileComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
